import { NewNames as NewNamesForm } from "@bgea-js/form-templates";
import donationHeaderSharingHopeCrisis from "../../../../src/content/sharinghopeincrisis/donationHeader";
import * as React from 'react';
export default {
  NewNamesForm,
  donationHeaderSharingHopeCrisis,
  React
};